export enum DecisionExportLockType {
  Products = 1,
  Ecomm = 2,
  MasterData = 3,
  MasterDataFtp = 4,
  EdiPriceList = 5,
  EdiPriceListFtp = 6
}

(DecisionExportLockType as any).__typeName = 'DecisionExportLockType';